module.exports = __webpack_public_path__ + "static/media/Amy Neuman.c2fcfd3a.png";